var $20112446b2d06d6e$exports = {};
$20112446b2d06d6e$exports = {
    "pending": `avventer`
};


export {$20112446b2d06d6e$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
